import { Injectable } from '@angular/core';
import {Observable, of} from "rxjs";
import {emptyWpmFile, IWpmFile} from "@retail-data-factory/rdf-angular-types-api";
import * as moment from "moment";

@Injectable({
  providedIn: 'root'
})
export class ApiWpmService {

  constructor() { }

  getFileList(month: Date):Observable<Array<IWpmFile>> {
    return of([
      {...emptyWpmFile, fileDateUpload: moment().toDate(), city: 'Москва', name: 'File1'},
      {...emptyWpmFile, fileDateUpload: moment().toDate(), city: 'Москва', name: 'File2'},
      {...emptyWpmFile, fileDateUpload: moment().toDate(), city: 'Москва', name: 'File3'}
    ]);
  }
  getFileDetail(fileId: string): Observable<IWpmFile> {
    return of({...emptyWpmFile});
  }

}
